const INTERNAL_HOSTNAMES = new Set([
  'tampaschoolofrealestate.com',
  'www.tampaschoolofrealestate.com',
  'tsre-us.myshopify.com',
]);

const PROTECTED_SHOPIFY_HOSTNAMES = new Set([
  'accounts.shopify.com',
  'checkout.shopify.com',
  'pay.shopify.com',
  'shop.app',
]);

const SKIPPED_PROTOCOLS = new Set([
  'javascript:',
  'mailto:',
  'sms:',
  'tel:',
]);

function isInternalHostname(hostname) {
  return (
    INTERNAL_HOSTNAMES.has(hostname) ||
    hostname.endsWith('.tampaschoolofrealestate.com')
  );
}

function shouldOpenInNewTab(link) {
  if (
    link.hasAttribute('data-keep-same-tab') ||
    link.hasAttribute('download') ||
    link.target === '_top' ||
    link.target === '_parent'
  ) {
    return false;
  }

  const href = link.getAttribute('href');

  if (!href || href.startsWith('#')) return false;

  let url;

  try {
    url = new URL(href, document.baseURI);
  } catch {
    return false;
  }

  if (
    SKIPPED_PROTOCOLS.has(url.protocol) ||
    !['http:', 'https:'].includes(url.protocol) ||
    isInternalHostname(url.hostname) ||
    PROTECTED_SHOPIFY_HOSTNAMES.has(url.hostname)
  ) {
    return false;
  }

  return true;
}

function secureExternalLink(link) {
  if (!shouldOpenInNewTab(link)) return;

  link.target = '_blank';

  const rel = new Set(
    (link.getAttribute('rel') || '')
      .split(/\s+/)
      .filter(Boolean)
  );

  rel.add('noopener');

  link.setAttribute('rel', [...rel].join(' '));
  link.setAttribute('data-external-link', '');
}

function processLinks(root) {
  if (root instanceof HTMLAnchorElement) {
    secureExternalLink(root);
  }

  if (root instanceof Element || root instanceof Document) {
    root.querySelectorAll('a[href]').forEach(secureExternalLink);
  }
}

processLinks(document);

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'attributes') {
      secureExternalLink(mutation.target);
      continue;
    }

    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) processLinks(node);
    });
  }
}).observe(document.documentElement, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['href'],
});
